import { createAction, props } from '@ngrx/store';
import {
  ErrorModel,
  TransferFilterParametersResponse,
  TransferListItemResponsePagedResponse,
} from '../../../core/cms-api/models';
import { TransferFilter } from './billing.transfers.models';

export const initTransfers = createAction(
  '[BillingTransfers] Init',
  props<{ operatorId: string; dateFrom?: string | null; dateTo?: string | null }>(),
);

export const loadTransfers = createAction('[BillingTransfers] Load transfers');
export const loadTransfersSuccess = createAction(
  '[BillingTransfers] Load transfers success',
  props<{ response: TransferListItemResponsePagedResponse }>(),
);
export const loadTransfersFailure = createAction(
  '[BillingTransfers] Load transfers failure',
  props<{ error: ErrorModel }>(),
);

export const loadTransferFilterParameters = createAction(
  '[BillingTransfers] Load filter parameters',
);
export const loadTransferFilterParametersSuccess = createAction(
  '[BillingTransfers] Load filter parameters success',
  props<{ filterParameters: TransferFilterParametersResponse }>(),
);
export const loadTransferFilterParametersFailure = createAction(
  '[BillingTransfers] Load filter parameters failure',
  props<{ error: ErrorModel }>(),
);

export const changeTransferFilter = createAction(
  '[BillingTransfers] Change filter',
  props<{ filter: TransferFilter }>(),
);
export const changeTransferFilterSuccess = createAction(
  '[BillingTransfers] Change filter success',
);

export const changeTransferPagination = createAction(
  '[BillingTransfers] Change pagination',
  props<{ pageIndex: number; pageSize: number }>(),
);
export const changeTransferPaginationSuccess = createAction(
  '[BillingTransfers] Change pagination success',
);

export const changeTransferDateRange = createAction(
  '[BillingTransfers] Change date range',
  props<{ dateFrom?: string | null; dateTo?: string | null }>(),
);
export const changeTransferDateRangeSuccess = createAction(
  '[BillingTransfers] Change date range success',
);

export const recallTransfer = createAction(
  '[BillingTransfers] Recall transfer',
  props<{ transferId: string }>(),
);
export const recallTransferSuccess = createAction('[BillingTransfers] Recall transfer success');
export const recallTransferFailure = createAction(
  '[BillingTransfers] Recall transfer failure',
  props<{ error: ErrorModel }>(),
);
